__turbopack_context__.v({
  "badge": "DataPipeline-module__q4w4Wq__badge",
  "bumpR1": "DataPipeline-module__q4w4Wq__bumpR1",
  "bumpR2": "DataPipeline-module__q4w4Wq__bumpR2",
  "bumpR3": "DataPipeline-module__q4w4Wq__bumpR3",
  "bumpR4": "DataPipeline-module__q4w4Wq__bumpR4",
  "drawPath": "DataPipeline-module__q4w4Wq__drawPath",
  "header": "DataPipeline-module__q4w4Wq__header",
  "hubBrain": "DataPipeline-module__q4w4Wq__hubBrain",
  "l1": "DataPipeline-module__q4w4Wq__l1",
  "l2": "DataPipeline-module__q4w4Wq__l2",
  "l3": "DataPipeline-module__q4w4Wq__l3",
  "l4": "DataPipeline-module__q4w4Wq__l4",
  "nodeIcon": "DataPipeline-module__q4w4Wq__nodeIcon",
  "nodePill": "DataPipeline-module__q4w4Wq__nodePill",
  "r1": "DataPipeline-module__q4w4Wq__r1",
  "r2": "DataPipeline-module__q4w4Wq__r2",
  "r3": "DataPipeline-module__q4w4Wq__r3",
  "r4": "DataPipeline-module__q4w4Wq__r4",
  "receiveDataBump": "DataPipeline-module__q4w4Wq__receiveDataBump",
  "section": "DataPipeline-module__q4w4Wq__section",
  "stage": "DataPipeline-module__q4w4Wq__stage",
  "svgLines": "DataPipeline-module__q4w4Wq__svgLines",
  "title": "DataPipeline-module__q4w4Wq__title",
});
